import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoodJobDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 329.899,
			y1: 78.5615,
			x2: 394.899,
			y2: 63.5615,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 315.827,
			y1: 78.4156,
			x2: 262.827,
			y2: 56.4156,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 54C398.582 54 395 57.5817 395 62C395 66.4183 398.582 70 403 70C407.418 70 411 66.4183 411 62C411 57.5817 407.418 54 403 54Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M403 59C401.343 59 400 60.3431 400 62C400 63.6569 401.343 65 403 65C404.657 65 406 63.6569 406 62C406 60.3431 404.657 59 403 59Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322 72.999C317.582 72.999 314 76.5807 314 80.999C314 85.4173 317.582 88.999 322 88.999C326.418 88.999 330 85.4173 330 80.999C330 76.5807 326.418 72.999 322 72.999Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M322 77.999C320.343 77.999 319 79.3422 319 80.999C319 82.6559 320.343 83.999 322 83.999C323.657 83.999 325 82.6559 325 80.999C325 79.3422 323.657 77.999 322 77.999Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(0.920735 0.390189 0.390189 -0.920735 127.568 32)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(-0.991998 -0.126254 -0.126254 0.991998 72 98)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(-0.484316 0.874893 0.874893 0.484316 115 35)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 106C75.5817 106 72 102.418 72 98C72 93.5817 75.5817 90 80 90C84.4183 90 88 93.5817 88 98C88 102.418 84.4183 106 80 106Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 101C78.3431 101 77 99.6569 77 98C77 96.3431 78.3431 95 80 95C81.6569 95 83 96.3431 83 98C83 99.6569 81.6569 101 80 101Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 98C4.58172 98 1 94.4183 1 90C1 85.5817 4.58172 82 9 82C13.4183 82 17 85.5817 17 90C17 94.4183 13.4183 98 9 98Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 93C7.34315 93 6 91.6569 6 90C6 88.3431 7.34315 87 9 87C10.6569 87 12 88.3431 12 90C12 91.6569 10.6569 93 9 93Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 37C115.582 37 112 33.4183 112 29C112 24.5817 115.582 21 120 21C124.418 21 128 24.5817 128 29C128 33.4183 124.418 37 120 37Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M120 32C118.343 32 117 30.6569 117 29C117 27.3431 118.343 26 120 26C121.657 26 123 27.3431 123 29C123 30.6569 121.657 32 120 32Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M119.3 117.65C119.3 119.67 117.67 121.3 115.65 121.3C113.63 121.3 112 119.67 112 117.65C112 115.63 113.63 114 115.65 114C117.67 114 119.3 115.63 119.3 117.65Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.043 121.173C340.833 121.183 340.623 121.133 340.433 121.003C339.983 120.693 339.863 120.083 340.173 119.633L345.933 111.193C346.103 110.943 346.383 110.783 346.683 110.763C346.963 110.733 347.283 110.863 347.483 111.083L351.203 115.173L357.873 104.133C358.033 103.873 358.293 103.703 358.593 103.663C358.893 103.633 359.193 103.733 359.413 103.943L363.463 107.973L372.013 95.4326C372.323 94.9826 372.933 94.8626 373.383 95.1726C373.833 95.4826 373.953 96.0926 373.643 96.5426L364.433 110.063C364.273 110.303 364.003 110.463 363.713 110.493C363.403 110.533 363.133 110.413 362.923 110.213L358.923 106.233L352.223 117.333C352.063 117.603 351.783 117.773 351.473 117.803C351.143 117.843 350.853 117.713 350.643 117.483L346.873 113.343L341.823 120.753C341.643 121.013 341.353 121.163 341.063 121.183L341.043 121.173Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0426 36.01C39.8326 36 39.6226 36.0499 39.4326 36.1799C38.9826 36.4899 38.8626 37.1 39.1726 37.55L44.9326 45.99C45.1026 46.24 45.3826 46.4001 45.6826 46.4201C45.9626 46.4501 46.2826 46.32 46.4826 46.1L50.2026 42.01L56.8726 53.0501C57.0326 53.3101 57.2926 53.48 57.5926 53.52C57.8926 53.55 58.1926 53.45 58.4126 53.24L62.4626 49.21L63.5 48.1826C63.6284 47.9243 63.5926 47.36 63.4326 47.12C63.2726 46.88 63.0026 46.7199 62.7126 46.6899C62.4026 46.6499 62.1326 46.77 61.9226 46.97L57.9226 50.95L51.2226 39.85C51.0626 39.58 50.7826 39.41 50.4726 39.38C50.1426 39.34 49.8526 39.47 49.6426 39.7L45.8726 43.84L40.8226 36.4299C40.6426 36.1699 40.3526 36.02 40.0626 36L40.0426 36.01Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 206,
			cy: 70,
			r: 70,
			fill: "#1C1C1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144 79C149.143 114.216 181.379 138.523 216 133.292",
			stroke: "#EAEAEA",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4019_40460",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 136,
			y: 0,
			width: 140,
			height: 140,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 206,
				cy: 70,
				r: 70,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4019_40460)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M209.143 109.057C197.578 106.315 173.208 92.7226 170.112 87.9828L170.107 87.967C167.732 84.3067 169.39 80.5106 170.274 78.9559C170.451 78.6629 170.594 78.4513 170.675 78.3343C170.627 78.2686 170.597 78.1907 170.59 78.1091C170.358 77.9282 169.899 77.5417 169.378 76.9469C168.25 75.6531 166.845 73.3934 166.846 70.0728C166.834 66.4561 168.108 64.6453 168.981 63.8362C169.037 63.7846 169.091 63.7369 169.144 63.6931C169.151 63.6531 169.164 63.6135 169.183 63.5752C169.272 63.3934 169.468 63.2988 169.659 63.3297C169.743 63.2815 169.791 63.2602 169.791 63.2602C169.791 63.2602 169.546 62.9021 169.309 62.2585C168.847 61.0558 168.384 58.8114 169.423 55.844C170.462 52.8766 173.301 51.8756 175.181 51.5363C175.617 51.4563 176.001 51.4138 176.296 51.3913C176.203 51.2609 176.183 51.0849 176.259 50.9312C176.351 50.7447 176.554 50.65 176.749 50.6883C176.734 50.615 176.718 50.5366 176.703 50.4535C176.234 48.0876 175.693 41.8252 182.796 41.3162C191.57 40.6807 208.843 52.572 208.843 52.572C208.843 52.572 207.411 41.5086 208.814 34.108C210.223 26.7232 213.764 23.0108 216.707 25.2769C217.835 26.1486 218.439 29.9458 219.036 34.6586L219.043 34.6626L219.052 34.6668L219.052 34.6672L219.053 34.6673C219.275 34.7771 219.367 35.0468 219.257 35.2697C219.227 35.3322 219.183 35.3844 219.132 35.4247C219.175 35.7695 219.218 36.1185 219.261 36.4708L219.511 38.4521C220.362 45.3154 221.472 52.8857 224.13 56.0789C224.87 56.9574 225.738 57.9513 226.675 58.9925C231.055 63.8291 233.448 69.8838 233.768 76.0403C233.775 76.0447 233.782 76.0492 233.788 76.0537C235.222 76.9966 236.905 78.102 238.757 79.2909C240.95 80.6997 243.365 82.2447 245.903 83.8366C247.447 84.7947 249.013 85.7633 250.616 86.7369C250.905 86.912 251.199 87.0898 251.493 87.2675C251.788 87.4457 252.083 87.6239 252.372 87.7995C257.913 91.1072 263.5 94.2401 268.076 96.3746C270.747 97.6163 273.8 98.9773 277.572 100.658C289.413 105.937 308.334 114.371 344.716 132.173L350.182 134.864L285.44 156.888L219.446 111.717L214.217 108.128C212.416 109.05 210.701 109.424 209.143 109.057Z",
					fill: "#272728"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.734 77.8304C169.489 82.7761 192.842 98.0486 204.185 101.597C209.666 103.3 217.819 95.6548 224.795 87.2816C233.046 77.3798 233.158 63.0336 225.195 52.889C224.334 51.7846 223.538 50.732 222.861 49.8036C220.434 46.4314 219.86 38.8019 219.493 31.8958C219.456 31.2311 219.42 30.5664 219.383 29.9018C219.094 24.3411 218.82 19.6238 217.622 18.556C214.846 16.0885 211.052 19.5428 209.128 26.8102C207.208 34.0939 207.858 45.2306 207.858 45.2306C207.858 45.2306 191.464 32.1541 182.667 32.1711C175.546 32.1794 175.645 38.4643 175.947 40.8574C176.011 41.4284 176.104 41.7842 176.104 41.7842C176.104 41.7842 175.378 41.7162 174.353 41.8305C172.453 42.0368 169.552 42.8356 168.306 45.7226C167.061 48.6096 167.365 50.881 167.742 52.1133C167.932 52.7719 168.152 53.1464 168.152 53.1464C168.152 53.1464 167.789 53.2766 167.303 53.6639C166.375 54.4096 164.977 56.1265 164.735 59.735C164.5 63.0473 165.743 65.4002 166.778 66.7702C167.466 67.6781 168.056 68.1452 168.056 68.1452C168.056 68.1452 167.844 68.3912 167.53 68.8372C166.538 70.3259 164.617 73.996 166.73 77.8142L166.734 77.8304Z",
					fill: "#868686"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.068 39.2226C191.113 39.5518 187.401 41.3834 188.191 46.0753",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.855 50.3176C183.218 50.5637 180.159 52.2198 181.013 56.8745",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M179.838 61.6605C178.333 62.3474 175.752 64.3858 176.986 69.0723",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M176.274 74.8281C174.465 76.4177 173.698 77.7334 174.552 81.9727",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.505 69.4015L168.353 68.0044",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.174 56.7121L167.911 53.6436",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.121 44.5969L175.858 41.5283",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.701 19.8989C215.346 22.7767 215.614 24.4254 216.828 26.284C217.759 27.7093 219.075 28.4765 219.075 28.4765",
					stroke: "#272728",
					strokeWidth: .9,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M343.06 137.256L276.931 154.673L214.276 104.973L209.311 101.024L207.41 99.5193L226.069 66.5078C226.069 66.5078 228.011 68.0367 231.09 70.4071C232.454 71.4486 234.055 72.6695 235.82 73.9857C237.908 75.5453 240.208 77.2563 242.627 79.0226C244.101 80.0869 245.594 81.1632 247.125 82.2471C247.677 82.6377 248.25 83.0401 248.802 83.4306C254.097 87.1197 259.45 90.6377 263.864 93.0887C274.532 98.9937 291.597 107.4 337.798 134.188L343.06 137.256Z",
					fill: "#868686"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.288 119.282L248.787 83.4509C246.693 81.9969 244.622 80.502 242.612 79.0428L221.425 110.663L232.288 119.282Z",
					fill: "#464649"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.5 72.9768L212.901 106.926C212.363 107.708 212.555 108.764 213.324 109.322L221.957 115.313C222.738 115.851 223.794 115.659 224.336 114.894L247.981 80.9846C248.518 80.2032 248.322 79.131 247.557 78.589L238.88 72.5577C238.098 72.02 237.042 72.2116 236.484 72.9811L236.5 72.9768Z",
					fill: "#F2C24F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.878 88.8163L220.567 82.0657C222.161 79.7786 224.838 78.5202 227.615 78.7571L235.804 79.4534C238.581 79.6902 241.015 81.3834 242.194 83.8912L245.69 91.3218C246.874 93.8457 246.631 96.7972 245.037 99.0843L240.348 105.835C238.755 108.122 236.078 109.38 233.301 109.143L225.112 108.447C222.335 108.21 219.9 106.517 218.721 104.009L215.225 96.5788C214.042 94.0548 214.285 91.1034 215.878 88.8163Z",
					fill: "#F2C24F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.525 90.1587L239.808 88.6184C238.4 85.635 235.499 83.6152 232.211 83.3401L230.514 83.1991C227.225 82.924 224.024 84.4242 222.144 87.1326L221.18 88.5277C219.3 91.2361 218.999 94.7561 220.407 97.7396L221.124 99.2798C222.532 102.263 225.433 104.283 228.722 104.558L230.419 104.699C233.707 104.974 236.908 103.474 238.789 100.766L239.753 99.3706C241.633 96.6622 241.934 93.1422 240.525 90.1587Z",
					fill: "#F2B014"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 38,
			height: 24,
			rx: 8,
			transform: "matrix(-1 0 0 1 292 11)",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266.884 31.7827C267.847 31.1988 267.847 29.8012 266.884 29.2173L256.278 22.7875C255.278 22.1814 254 22.9012 254 24.0702L254 36.9298C254 38.0988 255.278 38.8186 256.278 38.2125L266.884 31.7827Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 284 21)",
			fill: "#464649"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 275 21)",
			fill: "#464649"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 266 21)",
			fill: "#464649"
		})
	]
});
const ForwardRef = forwardRef(SvgGoodJobDark);
export default ForwardRef;
